import { render, staticRenderFns } from "./uno_consume_datatable.vue?vue&type=template&id=62007384&"
import script from "./uno_consume_datatable.vue?vue&type=script&lang=js&"
export * from "./uno_consume_datatable.vue?vue&type=script&lang=js&"
import style0 from "./uno_consume_datatable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports